'use strict';

import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    messages:               {}
  },
  actions: {
    setMessage: ({commit}, {key, message}) => commit('setMessage', {key, message}),
    clearMessage: ({commit}, {key}) => commit('clearMessage', {key}),
  },
  mutations: {
    setMessage: (state, {key, message}) => {
      Vue.set(state.messages, key, message);
    },
    clearMessage: (state, {key}) => {
      Vue.delete(state.messages, key);
    }
  },
  getters: {
    getMessage: state => {
      return ({key}) => state.messages[key];
    }
  }
};
